import { NgIf } from "@angular/common";
import { Component, Input } from "@angular/core";
import { CardComponent } from "../../ui/card";

@Component({
    selector: 'lpcr-notice-board-item',
    styleUrl: './notice-board-item.component.scss',
    templateUrl: './notice-board-item.component.html',
    imports: [
        NgIf,
        CardComponent
    ]
})
export class NoticeBoardItemComponent {

  @Input()
  public title: string = "";

  @Input()
  public base64Image: string = "";

  @Input()
  public contentText: string = "";

  @Input()
  public moreInformationURL: string = "";
   
  public isHidden = true;
  
  public showNotice()
  {
    this.isHidden = false;
  }

  public hideNotice()
  {
    this.isHidden = true;
  }

  public onMoreInformationClick()
  {
    globalThis.location.href = this.moreInformationURL;
  }

  
}
